import { render, staticRenderFns } from "./BarContactForm.vue?vue&type=template&id=13df0b3d&scoped=true"
import script from "./BarContactForm.vue?vue&type=script&lang=js"
export * from "./BarContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13df0b3d",
  null
  
)

export default component.exports